/**
 * @generated SignedSource<<cb1e59d33594693ab94cefb6ff89d960>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type src_issueTableHideDoneToggle_HideDoneItemsToggle_viewResult$data = {
  readonly " $fragmentSpreads": FragmentRefs<"ui_issueTableHideDoneToggle_HideDoneItemsToggle_viewResult">;
  readonly " $fragmentType": "src_issueTableHideDoneToggle_HideDoneItemsToggle_viewResult";
};
export type src_issueTableHideDoneToggle_HideDoneItemsToggle_viewResult$key = {
  readonly " $data"?: src_issueTableHideDoneToggle_HideDoneItemsToggle_viewResult$data;
  readonly " $fragmentSpreads": FragmentRefs<"src_issueTableHideDoneToggle_HideDoneItemsToggle_viewResult">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "staticViewInput"
    }
  ],
  "kind": "Fragment",
  "name": "src_issueTableHideDoneToggle_HideDoneItemsToggle_viewResult",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "staticViewInput",
          "variableName": "staticViewInput"
        }
      ],
      "kind": "FragmentSpread",
      "name": "ui_issueTableHideDoneToggle_HideDoneItemsToggle_viewResult"
    }
  ],
  "type": "JiraIssueSearchViewMetadata",
  "abstractKey": "__isJiraIssueSearchViewMetadata"
};

(node as any).hash = "726ada747eee2bce73de86cd027eeacc";

export default node;
